import {
  Type,
  Maybe,
  maybe,
  HTTP,
  map,
} from "@/lib";


import httpClient from "../../api/httpClient";

const statsMarket = Type("StatsMarket", {
  id: Maybe,
  country: String,
  nrUsers: Number,
  storesOverLimit: Number,
  avg_cpc_eur: Number,
  clicks: Number,
});

const makeStatsMarket = ({
  id,
  country,
  nrUsers,
  storesOverLimit,
  avg_cpc_eur,
  clicks,
}) =>
  statsMarket(
    maybe(id),
    country,
    nrUsers,
    storesOverLimit,
    avg_cpc_eur,
    clicks,
  );

export default {
  namespaced: true,

  state: {
    statsMarket: HTTP.Request.Inactive(),
  },

  mutations: {
    setStatsMarkets: (state, statsMarkets) => {
      state.statsMarket = HTTP.normalize(statsMarkets, {
        transform: makeStatsMarket,
      });
    },
  },

  getters: {
    statsMarket: ({ statsMarket }) =>
      map(statsMarket, ({ ids, byId }) => map(ids, id => byId[id])),
  },

  actions: {
    init({ commit }) {
      commit("setStatsMarkets", HTTP.Request.Pending());

      return httpClient.get(`/admin/getStatsForMarkets`)
        .then(response => commit("setStatsMarkets", HTTP.Request.Done(response.data)))
        .catch(err => commit("setStatsMarkets", err));
    },

    update({ commit }, { path, value }) {
      commit("update", { path, value });
    },
  },
};
